<script>
	import Modal from './modal.svelte'

	export let signupUnsuccessful

	let showModal = true
</script>

{#if showModal}
	<Modal on:close={() => (showModal = false)} width={500}>
		<div class="modal-inner">
			{#if signupUnsuccessful}
				<h1>Signup Unsuccessful</h1>
				<p>
					While we're working on fixing this, please subscribe directly
					<a
						href="https://lp.constantcontactpages.com/su/phH9Gwe"
						target="_blank"
						rel="noopener noreferrer">
						using this form
					</a>
					.
				</p>
			{:else}
				<h1>Signup Successful</h1>
				<p>Thank you for subscribing to our newsletter!</p>
			{/if}
		</div>
	</Modal>
{/if}
